import {
  Box,
  Button,
  Flex,
  HStack,
  Select,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/Card/Card';
import { useEffect, useState } from 'react';
import ResultsController from '../NewResults/controllers/ResultsController';
import ResultsController2 from './controllers/ResultsController';
import SingleTranscriptController from '../Audios/controllers/SingleAudioController';
import { useLocation } from 'react-router-dom';

function ResultsView() {
  const [data, setData] = useState([]);
  const [audits, setAudits] = useState([]);
  const [lotes, setLotes] = useState([]);
  const [selectedAudit, setSelectedAudit] = useState({ id: '', name: '' });
  const [selectedLote, setSelectedLote] = useState('');
  const [showResults, setShowResults] = useState(false);
  const [selectedAuditResults, setSelectedAuditResults] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentRecordingIndex, setCurrentRecordingIndex] = useState(0);
  const textColor = useColorModeValue('gray.700', 'white');
  const [selectedAuditName, setSelectedAuditName] = useState('');
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const auditNameFromQuery = queryParams.get('audit_name');
  const loteFromQuery = queryParams.get('lote');

  const LoadingIndicator = ({ isLoading }) => {
    return (
      <Box
        position="auto"
        top="200px"
        left="30px"
        display={isLoading ? 'block' : 'none'}
        color="#90cdf4"
      >
        Carregando <Spinner size="sm" />
      </Box>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const jwtToken = localStorage.getItem('access_token');
        const profiles = await ResultsController.listaudits(jwtToken);
        setData(profiles);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (auditNameFromQuery) {
      setSelectedAuditName(auditNameFromQuery);
      const selectedAudit = audits.find(audit => audit.audit_name === auditNameFromQuery);
      if (selectedAudit) {
        setSelectedAudit({ id: selectedAudit.audit_id, name: selectedAudit.audit_name });
        fetchLotes(selectedAudit.audit_id);
      }
    }
  }, [auditNameFromQuery, audits]);

  useEffect(() => {
    if (loteFromQuery && selectedAudit.id) {
      setSelectedLote(loteFromQuery);
    }
  }, [loteFromQuery, selectedAudit.id]);

  useEffect(() => {
    if (selectedAudit.id && selectedLote) {
      handleSearch();
    }
  }, [selectedAudit, selectedLote]);

  const handleAuditSelect = (e) => {
    setSelectedAuditName(e.target.value);
    const selectedName = e.target.value;
    const selectedAudit = audits.find(audit => audit.audit_name === selectedName);
    setSelectedAudit({ id: selectedAudit.audit_id, name: selectedAudit.audit_name });
    setSelectedLote('');
    fetchLotes(selectedAudit.audit_id);
  };

  const fetchLotes = async (auditId) => {
    const jwtToken = localStorage.getItem('access_token');
    const response = await ResultsController.listLotes(jwtToken, auditId);
    if (!response) {
      console.error("Failed to list lotes");
      return;
    }
    setLotes(response);
  };

  const handleLoteSelect = (e) => {
    setSelectedLote(e.target.value);
  };

  const handleSearch = async () => {
    try {
      const jwtToken = localStorage.getItem('access_token');

      setLoading(true);

      const selectedAudit = data.find((audit) => audit.audit_name === selectedAuditName);

      if (!selectedAudit) {
        console.log('Ficha não encontrada');
        setShowResults(false);
        setLoading(false);
        return;
      }

      const auditResults = await ResultsController2.listResults(jwtToken, selectedAudit.audit_name, selectedLote);

      if (auditResults && auditResults.length > 0) {
        setSelectedAuditResults(auditResults[0]);
        setCurrentRecordingIndex(0);
        setShowResults(true);
      } else {
        console.log('Resultados não encontrados para a ficha selecionada');
        setShowResults(false);
      }
    } catch (error) {
      console.error('Erro ao buscar resultados da ficha:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevious = () => {
    setCurrentRecordingIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNext = () => {
    if (selectedAuditResults) {
      setCurrentRecordingIndex((prevIndex) =>
        Math.min(prevIndex + 1, selectedAuditResults.recordings.length - 1)
      );
    }
  };

  useEffect(() => {
    const fetchAudits = async () => {
      const jwtToken = localStorage.getItem('access_token');
      const response = await ResultsController.listaudits(jwtToken);
      if (!response) {
        console.error("Failed to list");
        return;
      }
      setAudits(response);
    };

    fetchAudits();
  }, []);

  return (
    <Flex direction="column" height="100%" width="100%">
      <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
        <VStack align="stretch" spacing={4} p={5}>
          <HStack justifyContent="space-between">
            <HStack justifyContent="space-between" alignItems="center">
              <Select
                placeholder="Selecionar ficha"
                value={selectedAudit.name}
                onChange={handleAuditSelect}
                width="200px"
              >
                {audits && audits.length > 0 && audits.map((audit, index) => (
                  <option key={index} value={audit?.audit_name}>
                    {audit?.audit_name}
                  </option>
                ))}
              </Select>
              <Select
                placeholder="Selecionar Lote"
                value={selectedLote}
                onChange={handleLoteSelect}
                width="300px"
                isDisabled={!selectedAudit.id}
              >
                {lotes && lotes.length > 0 && lotes.map((lote, index) => (
                  <option key={index} value={lote?.lote}>
                    {lote?.lote}
                  </option>
                ))}
              </Select>
              <Button onClick={handleSearch} colorScheme="blue" minWidth="200px" width="auto">
                Buscar
              </Button>
            </HStack>
          </HStack>
          {loading ? (
            <LoadingIndicator isLoading={loading} />
          ) : (
            showResults &&
            selectedAuditResults &&
            selectedAuditResults.recordings.length > 0 && (
              <Box borderWidth="1px" borderRadius="lg" overflow="hidden" p={4}>
                <HStack justifyContent="space-between">
                  <Text fontWeight="bold" color={textColor}>
                    {selectedAuditResults.audit_name}
                  </Text>
                  <HStack>
                    <Button size="sm" onClick={handlePrevious} isDisabled={currentRecordingIndex === 0}>
                      Anterior
                    </Button>
                    <Button
                      size="sm"
                      onClick={handleNext}
                      isDisabled={currentRecordingIndex === selectedAuditResults.recordings.length - 1}
                    >
                      Próximo
                    </Button>
                  </HStack>
                </HStack>
                <Recording
                  recording={selectedAuditResults.recordings[currentRecordingIndex]}
                  textColor={textColor}
                />
                <Box
                  borderWidth="1px"
                  borderRadius="md"
                  p={4}
                  mt={4}
                  maxH="200px"
                  overflowY="scroll"
                  bg={useColorModeValue('gray.50', 'gray.700')}
                  color={textColor}
                >
                  <Text>Nota desta Ficha: </Text>
                </Box>
              </Box>
            )
          )}
        </VStack>
      </Card>
    </Flex>
  );
}

function Recording({ recording, textColor }) {
  const [audioUrl, setAudioUrl] = useState(null);
  const [isAudioLoading, setIsAudioLoading] = useState(false);
  const [currentAudioUrl, setCurrentAudioUrl] = useState(null);

  const loadAudio = async () => {
    if (!currentAudioUrl) {
      setIsAudioLoading(true);
      try {
        const url = await SingleTranscriptController.getAudio(recording.idtranscripts);
        setCurrentAudioUrl(url);
      } catch (error) {
        console.error('Erro ao buscar o áudio:', error);
      } finally {
        setIsAudioLoading(false);
      }
    }
  };

  const formatTranscriptText = (text) => {
    if (!text) {
      return <Text>Nenhuma transcrição disponível</Text>;
    }
  
    return text.split('\n').map((line, index) => (
      <Text key={index}>{line}</Text>
    ));
  };

  useEffect(() => {
    setCurrentAudioUrl(null);
  }, [recording]);

  return (
    <Box p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue('gray.50', 'gray.700')} color={textColor}>
      <Box borderWidth="1px" borderRadius="md" p={4} mb={4} bg={useColorModeValue('gray.200', 'gray.600')} color={textColor}>
        <HStack justifyContent="space-between">
          <Text fontWeight="bold">{recording.recording_path}</Text>
          {!currentAudioUrl && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-play"
              style={{ cursor: 'pointer' }}
              onClick={loadAudio}
            >
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
          )}
          <Box ml={!currentAudioUrl ? '0' : '-50px'}>
            {isAudioLoading ? (
              <Text>Carregando áudio...</Text>
            ) : currentAudioUrl ? (
              <audio id={`audio-${recording.idtranscripts}`} controls autoPlay>
                <source src={currentAudioUrl} type="audio/mp3" />
                Seu navegador não suporta o elemento de áudio.
              </audio>
            ) : null}
          </Box>
          <Text fontWeight="bold">{recording.idtranscripts}</Text>
          <Text fontWeight="bold">{recording.date_inserted}</Text>
        </HStack>
      </Box>
      <Box
        borderWidth="1px"
        borderRadius="md"
        p={4}
        mt={4}
        maxH="200px"
        overflowY="scroll"
        bg={useColorModeValue('gray.50', 'gray.700')}
        color={textColor}
      >
        {recording.questions.length ? (
          <Table variant="striped" colorScheme="blue.900" mt={4} width="100%">
            <Thead>
              <Tr>
                <Th>Pergunta</Th>
                <Th>Resposta</Th>
              </Tr>
            </Thead>
            <Tbody>
              {recording.questions.map((question, index) => (
                <Tr key={index} bg={index % 2 === 0 ? '#dddcdc1f' : 'transparent'}>
                  <Td>{question.question_name}</Td>
                  <Td>{question.resposta_resumida}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        ) : (
          <Text mt={4} color={textColor}>
            No questions available for this recording.
          </Text>
        )}
      </Box>
      <Box
        borderWidth="1px"
        borderRadius="md"
        p={4}
        mt={4}
        maxH="400px"
        overflowY="scroll"
        bg={useColorModeValue('gray.50', 'gray.700')}
        color={textColor}
      >
        {formatTranscriptText(recording.transcript_text)}
      </Box>
    </Box>
  );
}

export default ResultsView;